(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["video"] && !Shopify.designMode) return;
  try {
    function muteAllVideos() {
    document.querySelectorAll('video').forEach(function(v) {
      v.muted = true;
    });
  }

  // Al cargar la página
  muteAllVideos();

  // Cuando se añaden videos dinámicamente (deferred media)
  document.addEventListener('click', function() {
    setTimeout(muteAllVideos, 500);
  });

  // Observer para detectar videos nuevos en el DOM
  var observer = new MutationObserver(muteAllVideos);
  observer.observe(document.body, { childList: true, subtree: true });
  } catch(e) { console.error(e); }
})();

})();
